import getEnv from "../helpers/getEnv.js";

export default function removeCartItem(key, callback) {
  if (getEnv() === "development") {
    console.log(`product ${key} removed from card`);
  } else {
    const url = '/assets/components/minishop2/action.php';
    let xhr = new XMLHttpRequest();
    xhr.open('POST',url,true);
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhr.setRequestHeader("Accept", "application/json, text/javascript, */*; q=0.01");
    xhr.onreadystatechange = function() {
      if(xhr.readyState == XMLHttpRequest.DONE && xhr.status == 200) {
        callback(JSON.parse(xhr.response).data);
      }
    };

    xhr.send(`ms2_action=cart/remove&ctx=web&key=${key}`);
  }
}



// WEBPACK FOOTER //
// ./src/js/api/removeCartItem.js